import {
  RoleDetailsFormValues,
  RoleDetailsModel,
  RoleModifierField,
} from './types';

export function toRoleDetailsFormValues(
  roleDetails: RoleDetailsModel,
): RoleDetailsFormValues {
  return {
    name: roleDetails.name,
    teamId: roleDetails.teamId,
    description: roleDetails.description,
    modifiers: roleDetails.modifiers.map(modifierField => ({
      id: modifierField.id,
      value: modifierField.value,
    })),
    selectedPermissionIds: [...roleDetails.selectedPermissionIds],
  };
}

export function applyRoleDetailsFormValues(
  roleDetails: RoleDetailsModel,
  values: RoleDetailsFormValues,
): RoleDetailsModel {
  const modifierValueById = new Map(
    values.modifiers.map(modifierField => [
      modifierField.id,
      modifierField.value,
    ]),
  );

  return {
    ...roleDetails,
    name: values.name,
    teamId: values.teamId,
    description: values.description,
    selectedPermissionIds: [...values.selectedPermissionIds],
    modifiers: roleDetails.modifiers.map(modifierField => ({
      ...modifierField,
      value: modifierValueById.get(modifierField.id) ?? modifierField.value,
    })),
  };
}

export function cloneModifierFields(
  modifierFields: RoleModifierField[],
): RoleModifierField[] {
  return modifierFields.map(modifierField => {
    if (modifierField.inputType === 'text') return { ...modifierField };

    return {
      ...modifierField,
      options: modifierField.options.map(option => ({ ...option })),
    };
  });
}
